import React from "react";
import Popup from "./Popup";
import Message from "./Message";
import Logo from "./Logo";
import { useTranslation } from "react-i18next";
import { useThemeContext } from "../contexts/ThemeContext";
import OfficesSelect from "./form/OfficesSelect";

function ConfirmModal({
  title,
  question,
  onClose,
  onConfirm,
  confirmButtonText,
  loadingText,
  deleteErrorMessage,
  deleteLoading,
  selectedForDelete,
  setSelectedForDelete,
  isOfficeRequired = false,
  withClose = true,
}) {
  const { t } = useTranslation();
  const { theme } = useThemeContext();
  return (
    <Popup withOverlay withClose={withClose} onClose={onClose}>
      <div className="pl-3 pr-3">
        <div className="mt-3 text-center">
          <Logo className="logo mb-3" src={theme.logo} />
          <h1 className="mb-4">{title}</h1>
        </div>
        {isOfficeRequired && <div className="w-100 mb-3">
          <label htmlFor="officeId" className="form-label">
            {t("Select Void Location")} *
          </label>
          <OfficesSelect
            id="officeId"
            onChange={(officeId) => {
              setSelectedForDelete({ ...selectedForDelete, office_id: officeId });
            }}
            defaultOfficeIds={[selectedForDelete?.office_id]}
          />
        </div>}
        {question && (
          <Message
            className="text-center mb-3"
            type="message"
            message={question}
          />
        )}
        {deleteErrorMessage && (
          <p className="text-danger mt-3 mb-3" style={{ color: "red" }}>
            {deleteErrorMessage}
          </p>
        )}
        {onClose ? (
          <div className="row">
            <div className="col-xs-6">
              <button className="btn btn-secondary mr-1" onClick={onClose}>
                {t("Dismiss")}
              </button>
            </div>
            <div className="col-xs-6">
              <button
                className="btn btn-primary mr-1"
                onClick={onConfirm}
                disabled={deleteLoading || (isOfficeRequired && !selectedForDelete?.office_id)}
              >
                {deleteLoading
                  ? loadingText ?? "Deleting..."
                  : confirmButtonText ?? t("Confirm")}
              </button>
            </div>
          </div>
        ) : (
          <div>
            <button
              style={{ width: "100%" }}
              className="btn btn-primary mr-1"
              onClick={onConfirm}
            >
              {confirmButtonText ?? t("Confirm")}
            </button>
          </div>
        )}
      </div>
    </Popup>
  );
}

export default ConfirmModal;
